import { GetMethod } from "../../methods/GetMethod";
import { IChecklistByTimestampResponse } from "../common/response.types";

export class GetChecklistsByTimestampEndpoint extends GetMethod<IChecklistByTimestampResponse> {
  constructor() {
    super(`${process.env.REACT_APP_API_URL}/checklists/timestamp`);
  }
}
